import React, { useState } from "react"
import { MobileStyles } from "../../styles/index"
import { css } from '../../page-helpers/aphrodite-export';

export default ({ onClickAction, arrowDown }) => {
    return (
        <div className="arrowCtn"
            onClick={
                (e) => { onClickAction() }
            } >
            <div className="bounce">
                <i className={css(MobileStyles.arrowBase,
                    MobileStyles.arrowBlack,
                    arrowDown ? MobileStyles.arrowDown : MobileStyles.arrowUp)}></i>
            </div>
        </div>
    );
}